import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router, Scroll } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { F2fapiService } from '../../../services/f2fapi.service';
import { HelperService } from '../../../services/helper.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  public restaurantId: any = null;
  public restaurants: any[] = [];

  public isStoreDropDown: boolean;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Profile' }, { title: 'Sign Out' }];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    public f2fService: F2fapiService,
    private router: Router,
    private helper: HelperService,
    private authService: NbAuthService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
  ) {

    this.messageService.getMessage().subscribe(message => {
      if (message === 'Restaurant') {
        this.getRestaurants();
      }
    });

    /**
     * when site init 1st time
     */
    const routeFlag = this.helper.checkRouteForStoreDropdown(window.location.pathname);
    if (routeFlag === true) this.isStoreDropDown = false;
    else this.isStoreDropDown = true;

    /**
     * when route changes
     */
    this.router.events.subscribe((data) => {
      if (data instanceof Scroll) {
        const secondRouteFlag = this.helper.checkRouteForStoreDropdown(data.routerEvent.url);
        if (secondRouteFlag === true) this.isStoreDropDown = false;
        else this.isStoreDropDown = true;
      }
    });
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.getUserProfileData();
    // this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => this.redirect(title),
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  redirect(title) {
    if (title === 'Profile') {
      this.router.navigate(['/pages/profile']);
    } else if (title === 'Sign Out') {
      this.logout();
    }
  }

  getUserProfileData() {
    this.f2fService.getUserProfile().then(data => {
      this.user = data;

      const selectedRestaurant = localStorage.getItem('selectedRestaurant');
      if (selectedRestaurant) {
        this.helper.selectedRestaurantId = this.helper.getLocalRestaurant();
        this.restaurantId = this.helper.getLocalRestaurant();
      } else {
        this.helper.setRestaurant(this.user.restaurants[0]);
        this.restaurantId = this.helper.getLocalRestaurant();
      }
      this.getRestaurants();
    }, err => {

    });
  }

  getUserName() {
    if (this.user !== null && this.user !== '' && this.user !== undefined) {
      return this.user.firstname + ' ' + this.user.lastname;
    } else {
      return '';
    }
  }

  // get logged in user all restaurants
  getRestaurants() {
    this.f2fService.getRestaurantsList(0, 1).then(data => {
      this.restaurants = this.sortArray(data);
      this.cdr.detectChanges();
    }, err => {
    });
  }

  // sort name wise active restaurant
  sortArray(array) {
    return array.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
  }

  restaurantChange(value) {
    this.restaurantId = value;
    const resturantName = this.restaurants.filter((list: any) => list._id === value);
    this.helper.setRestaurant(this.restaurantId);
    this.helper.setRestaurantName(resturantName[0].name);
    location.reload();
  }

  logout() {
    this.helper.clearLocalStorage();
    this.authService.logout('email');
    this.router.navigate(['/auth/signin']);
  }
}
